import { Button } from "@exopengithub/exokit/v2";
import { IconMoodSadDizzy } from "@tabler/icons-react";
import { LoadingState } from "molecules/loadingState/LoadingState";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";
import { buildLazyReloadUrl } from "./lazyReloadUrl.js";

export function DynamicImportFailedError() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const hasReloaded = searchParams.has("lr");

	useEffect(() => {
		if (hasReloaded) {
			// Drop the marker so it doesn't leak into history/shared links and blocks a later reload attempt.
			const url = new URL(location.href);
			url.searchParams.delete("lr");
			window.history.replaceState(window.history.state, "", url);
			return;
		}
		const reloadUrl = buildLazyReloadUrl(location.href);
		if (reloadUrl) {
			location.replace(reloadUrl);
		}
	}, [hasReloaded]);

	if (!hasReloaded) {
		return <LoadingState />;
	}

	return (
		<div className="mx-auto flex max-w-[600px] flex-col items-center justify-center gap-4 px-6 py-10">
			<IconMoodSadDizzy size={60} className="text-red-500" />
			<div className="text-xl font-medium">
				{t("The page you're looking for is taking a siesta")}
			</div>
			<div>
				{t(
					"This problem can most likely be resolved by reloading the page. Should the problem persist after reload, please contact support.",
				)}
			</div>
			<div className="flex gap-4">
				<Button
					type="button"
					onClick={() => {
						navigate(-1);
					}}
				>
					{t("Go back")}
				</Button>
				<Button
					type="button"
					onClick={() => {
						location.reload();
					}}
					variant="secondaryGray"
				>
					{t("Reload the page")}
				</Button>
			</div>
		</div>
	);
}
